import * as React from 'react';
import { SummaryTableChart } from '../../../interface/MyInterfaces';
import { numberWithCommas } from '../../Common/Helpers';

export class Summary extends React.Component<SummaryTableChart, {}> {
    render() {
        if (this.props.SpendingSummaryTable !== undefined) {
            return <div className="summary_div">
                <h5>Date Range:  {this.props.start_year} Q1 - {this.props.end_year} Q4</h5>
                <table className="table summary">
                    <tbody>
                        <tr><td>Unique employees:</td><td>{numberWithCommas(this.props.SpendingSummaryTable.distinct_emp_count)}</td><td>Total employee transactions:</td><td>{numberWithCommas(this.props.SpendingSummaryTable.emp_record_count)}</td>
                        </tr>
                        <tr><td>Unique vendors:</td><td>{numberWithCommas(this.props.SpendingSummaryTable.distinct_vendor_count)}</td><td>Total vendor transactions:</td><td>{numberWithCommas(this.props.SpendingSummaryTable.vendor_record_count)}</td>
                        </tr>
                        <tr><td>Unique subcontracts:</td><td>{numberWithCommas(this.props.SpendingSummaryTable.distinct_subaward_count)}</td><td>Total subcontract transactions:</td><td>{numberWithCommas(this.props.SpendingSummaryTable.subaward_record_count)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        }
        else
            return <div>Loading...</div>
    }
}